import { SxProps, Theme, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TooltipExplainNoTradeValue = ({ sxIcon = {}, icon }: { sxIcon?: SxProps<Theme>; icon?: JSX.Element }) => {
  return (
    <Tooltip
      arrow
      placement="top"
      title="This field has no data from the source government. Some products are measured in weight, others in quantities. Some government sources provide all fields, while others do not."
    >
      {icon || <InfoOutlinedIcon color="action" sx={{ fontSize: 16, ...sxIcon }} />}
    </Tooltip>
  );
};

export default TooltipExplainNoTradeValue;
